(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    
  const startQuizBtn = document.querySelector('.start-quiz');
  const takeQuizContainer = document.querySelector('.take-quiz');
  const showQuizContainer = document.querySelector('.quiz-container');
  const quizContainer = document.querySelector('.quiz');

  startQuizBtn.onclick = function(){
   takeQuizContainer.style.display= 'none';
    showQuizContainer.style.display = 'flex';
  }

  // quiz js


  const data = [
    {
      question: "What is your body’s natural sleep temperature?",
      options: {
        a: 'I tend to run hot',
        b: 'I tend to feel cold',
        c: 'I am somewhere in the middle',
        d: 'I am not sure'
      },
      results: {
        a: 'Knitted weighted blanket',
        b: 'Sherpa weighted blanket',
        c: 'Cotton weighted blanket',
        d: 'Velvet weighted blanket'
    }
    },
    {
      question: "Do you sleep solo, or with a partner?",
      options: {
        a: 'Solo',
        b: 'Partner'
      },
      results: {
        a: 'Single',
        b: 'Double'
      }
    },
    {
      question: "How much do you weigh individually if you sleep alone/or combined body weight of you and your partner?<br/> (weird question, we know - but your secret is safe with us! 🙂) .",
      options: {
        a: 'Less than 70 kgs',
        b: '70-90 kgs',
        c: '90-115 kgs',
        d: 'Over 115 kgs'
      },
      results: {
        a: '5kg Blanket',
        b: '7kg blanket',
        c: '12kg blanket',
        d: '12/14 kg blanket (both will suit you well - just depends on your comfort level 🙂)'
      }
    }
  ]
  const images = {
    a: 'https://cdn.shopify.com/s/files/1/0604/5289/7014/files/0K4A0645.jpg?v=1686041672',
    b: 'https://cdn.shopify.com/s/files/1/0604/5289/7014/files/weighted_blanket_benefits.jpg?v=1670932440',
    c: 'https://cdn.shopify.com/s/files/1/0604/5289/7014/files/Kanu-IMG-373C8232-09DB-470C-92CD-DF86734133FC_c555450e-eb7b-4cf9-9ad3-e52691789adf.jpg?v=1686053750',
    d: 'https://cdn.shopify.com/s/files/1/0604/5289/7014/files/MIDNIGHT_VELVET_11_c31c6637-2219-4597-b167-0395456bc0ba.jpg?v=1685609604'
  }
  const links = {
    a: 'https://tuckedin.in/products/knitted-weighted-blankets',
    b: 'https://tuckedin.in/products/sherpa-weighted-blankets',
    c: 'https://tuckedin.in/products/cotton-weighted-blankets',
    d: 'https://tuckedin.in/products/velvet-weighted-blankets'
  }
  //keep currentquesiton track
  let questionCounter = 0;
  const selectedAnswers = [];
  var endImageOption;
  // console.log(answerContainers)
  const nextbtn = document.querySelector('.nextbutton');

  function showQuestion(data, currentQuestion, quizContainer) {
    const output = [];
    const answers=[];
    const question = '<div class="question">'+ data[currentQuestion].question + '</div>';


    for(option in data[currentQuestion].options){
      answers.push(
        '<label>'+
      '<input type="radio" name= "question' + currentQuestion + '" value="'+option+ '" />' + '<span class="label-text">' + data[currentQuestion].options[option] + '</span>'
        + '</label>'
      );
    }
    // add this question and its answers to the output
        output.push(
          question
          + '<div class="answers">' + answers.join('') + '</div>')

    quizContainer.innerHTML = output;
    nextbtn.style.visibility = 'hidden';
  }
  showQuestion(data, questionCounter, quizContainer);

  //show the next button
  quizContainer.addEventListener('click', () =>{  if(quizContainer.querySelector('input[name="question'+questionCounter+'"]:checked')){
      nextbtn.style.visibility = 'visible';
    }
    else{
      nextbtn.style.visibility = 'hidden';
    }
  })
  //on button click
  nextbtn.onclick = function() {
    // console.log(data[questionCounter])
      var selectedAnswer = quizContainer.querySelector('input[name="question'+questionCounter+'"]:checked').value ;
     selectedAnswers.push(data[questionCounter].results[selectedAnswer]);

    // endimage option
    if(questionCounter == 0 ){
      endImageOption = selectedAnswer;
    }
    console.log("endImageOption1", endImageOption);
     //update question counter
    questionCounter += 1;
     if(questionCounter < data.length){
       showQuestion(data, questionCounter, quizContainer);
     }
     else{
       showQuizEnd(endImageOption);
     }
 
    // console.log(selectedAnswers)
  }
  function showQuizEnd(endImage){
    const quizResultContainer = document.querySelector('.quiz-result-container');
     showQuizContainer.style.display = 'none';
    quizResultContainer.innerHTML = "<div class='quiz-result'> <div class='quiz-image'> <img src='"+ images[endImage] + "' loading='lazy'> </div>" + 
      "<div class='quiz-end'>" +
      "<div class='quiz-text'>" +
      "Thank You for taking the quiz.<br/>Here is our recommendation for you : <br/>" + 
      "<a href='" +
      links[endImage] +
      "' class='full-unstyled-link' >" +
      selectedAnswers.join(", ") +
      "</a>" +
      "</div>" +
      "</div>" +
      "</div>";
     nextbtn.style.visibility = 'hidden';
  }

  } catch(e) { console.error(e); }
})();
})();
